/* Experiencia "puntos clave": puntos sobre la foto REAL; al tocarlos se abre su explicación (y una foto de detalle si
   la hay). En computador la lista de al lado se ilumina con el punto.
   Datos (nayhogar.puntos): { "foto": 1, "puntos": [ { "x": 42, "y": 30, "titulo": "Tapa hermética", "texto": "...", "foto": 4 } ] }
         o directamente la lista [ {x, y, titulo, texto, foto}, ... ] (usa la foto 1). x, y en % de la foto. */
NHX.registrar('puntos', function (root, d, x) {
  const P = x.producto();
  const mp = P.puntos;
  const lista = Array.isArray(d) ? d : (Array.isArray(d.puntos) ? d.puntos : (Array.isArray(mp) ? mp : (mp && Array.isArray(mp.puntos) ? mp.puntos : [])));
  const pts = lista.map(p => ({ x: x.num(p.x), y: x.num(p.y), t: p.titulo || p.texto || '', tx: p.titulo ? (p.texto || '') : (p.detalle || ''), f: x.foto(p.foto) })).filter(p => p.x != null && p.y != null && p.t);
  const f = x.foto(Array.isArray(d) ? 1 : (d.foto || (mp && mp.foto) || 1));
  if (!pts.length || !f) return false;
  root.innerHTML =
    '<div class="xpu">' +
      '<div class="xpu__stage nhx-stage" style="aspect-ratio:' + (f.ar || 1) + '">' +
        x.imgTag(f, 'xpu__img nhx-prod') +
        pts.map((p, i) => '<button type="button" class="xpu__pin" style="left:' + p.x + '%;top:' + p.y + '%" data-i="' + i + '" aria-label="' + x.esc(p.t) + '" aria-expanded="false"><span>' + (i + 1) + '</span></button>').join('') +
        '<div class="xpu__card" role="dialog" aria-live="polite" hidden><button type="button" class="xpu__x" aria-label="Cerrar">×</button><div class="xpu__cf"></div><b class="xpu__ct"></b><p class="xpu__cx"></p></div>' +
        x.pista('Toca los puntos', 'toca') +
      '</div>' +
      '<ol class="xpu__list">' + pts.map((p, i) => '<li><button type="button" data-i="' + i + '"><span>' + (i + 1) + '</span><div><b>' + x.esc(p.t) + '</b>' + (p.tx ? '<p>' + x.esc(p.tx) + '</p>' : '') + '</div></button></li>').join('') + '</ol>' +
    '</div>';
  const st = root.querySelector('.xpu__stage'), card = st.querySelector('.xpu__card');
  const pins = Array.from(st.querySelectorAll('.xpu__pin')), items = Array.from(root.querySelectorAll('.xpu__list [data-i]'));
  let abierto = -1, tour = true;
  function abrir(i, manual) {
    if (manual) { tour = false; st.classList.add('is-tocado'); }
    abierto = i;
    pins.forEach((b, k) => { b.classList.toggle('on', k === i); b.setAttribute('aria-expanded', k === i); });
    items.forEach((b, k) => b.classList.toggle('on', k === i));
    if (i < 0) { card.hidden = true; return; }
    const p = pts[i];
    card.querySelector('.xpu__ct').textContent = p.t;
    card.querySelector('.xpu__cx').textContent = p.tx;
    card.querySelector('.xpu__cf').innerHTML = p.f ? x.imgTag({ src: p.f.med || p.f.src }, '', { alt: p.t }) : '';
    card.classList.toggle('has-f', !!p.f);
    card.classList.toggle('is-izq', p.x > 55);
    card.classList.toggle('is-arriba', p.y > 60);
    card.style.left = p.x + '%'; card.style.top = p.y + '%';
    card.hidden = false;
    card.classList.remove('in'); void card.offsetWidth; card.classList.add('in');
  }
  pins.forEach(b => b.addEventListener('click', e => { e.stopPropagation(); const i = +b.dataset.i; abrir(abierto === i ? -1 : i, true); }));
  items.forEach(b => b.addEventListener('click', () => abrir(+b.dataset.i, true)));
  if (x.fino) items.forEach(b => b.addEventListener('mouseenter', () => abrir(+b.dataset.i, true)));
  card.querySelector('.xpu__x').addEventListener('click', e => { e.stopPropagation(); abrir(-1, true); });
  st.addEventListener('click', e => { if (!e.target.closest('.xpu__card')) abrir(-1, true); });
  root.addEventListener('keydown', e => { if (e.key === 'Escape') abrir(-1, true); });
  // recorrido corto al verla: muestra cada punto una vez
  x.alVer(st, () => {
    pins.forEach((b, k) => setTimeout(() => b.classList.add('in'), 120 * k));
    if (x.reduce) return;
    let k = 0;
    const sig = () => { if (!tour) return; if (k >= Math.min(pts.length, 4)) { abrir(-1); return; } abrir(k++); setTimeout(sig, 2300); };
    setTimeout(sig, 900);
  }, 0.5);
});
